import Vue from 'vue'

const bus = new Vue()

if (process.env.NODE_ENV === 'development') window.bus = bus

export default bus



// WEBPACK FOOTER //
// ./src/utils/event_bus.js